import SEOMeta from '@/components/base/SEOMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';

// We'll use a contact form - let me create it inline since get_form_url is a tool call
export default function AboutPage() {
  return (
    <>
      <SEOMeta
        title="关于我们 - 品牌介绍与联系方式"
        description="星空传媒致力于为用户提供最优质的高清影视内容。了解星空传媒的品牌故事、口碑评价和联系方式，加入我们畅享精彩视频世界。"
        keywords="星空传媒,关于星空传媒,星空传媒联系方式,星空传媒品牌介绍"
        canonicalUrl="https://sportzup.github.io/about"
        ogTitle="关于我们 - 星空传媒品牌介绍"
        ogDescription="了解星空传媒的品牌故事、口碑评价和联系方式，畅享精彩视频世界。"
      />

      <Navbar />

      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2">
              关于星空传媒
            </h1>
            <p className="text-sm text-foreground-500 mb-10">
              汇聚精彩，点亮生活
            </p>

            <div className="prose-custom space-y-12">
              <div>
                <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-4">
                  品牌故事
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    星空传媒成立于2020年，是一家专注于高品质影视内容聚合与分发的在线视频平台。我们的名字"星空"寓意着浩瀚无际的影视世界，如同璀璨的星空一般，每一部作品都是一颗闪耀的星辰，共同编织成令人沉醉的视觉盛宴。
                  </p>
                  <p>
                    创始团队来自国内一线互联网公司和影视行业，拥有丰富的技术研发经验和内容运营能力。我们深谙用户对优质影视内容的渴望，因此从创立之初就确立了"免费、高清、无广告"的核心理念，致力于为广大用户提供最佳的在线观影体验。
                  </p>
                  <p>
                    经过多年的发展，星空传媒已积累超过五万部高清视频资源，涵盖电视剧、电影、综艺、动漫、纪录片、音乐MV、少儿节目等多元内容品类。平台月活跃用户突破八千万，成为国内领先的免费影视内容平台之一。
                  </p>
                </div>
              </div>

              <div className="relative rounded-2xl overflow-hidden aspect-[21/9]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20media%20company%20office%20with%20large%20screens%20displaying%20cinematic%20content%2C%20warm%20ambient%20lighting%2C%20creative%20workspace%20with%20film%20posters%20on%20wall%2C%20professional%20environment%2C%20clean%20minimalist%20design%2C%20golden%20hour%20warm%20light&width=1600&height=684&seq=xk-about-banner&orientation=landscape"
                  alt="星空传媒办公环境"
                  className="w-full h-full object-cover"
                  title="星空传媒 - 品牌文化"
                />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-4">
                    <i className="ri-eye-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                    我们的愿景
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    成为中文互联网最受欢迎的免费影视内容平台，让每个人都能轻松享受高品质的视听娱乐体验。
                  </p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mb-4">
                    <i className="ri-heart-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                    我们的使命
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    用技术连接内容与用户，打破观影门槛，让优质影视内容触手可及，丰富每一个人的精神文化生活。
                  </p>
                </div>
                <div className="p-6 rounded-xl bg-background-100 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-600 mb-4">
                    <i className="ri-shield-check-line text-2xl"></i>
                  </div>
                  <h3 className="text-lg font-heading font-semibold text-foreground-950 mb-2">
                    核心价值观
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    用户至上、内容为王、技术创新、诚信为本。我们始终坚守初心，为用户创造真正的价值。
                  </p>
                </div>
              </div>

              <div>
                <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-4">
                  用户口碑
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {[
                    {
                      name: '张先生',
                      role: '资深剧迷',
                      comment: '星空传媒真的是我见过最好的免费影视平台！画质清晰、更新快，而且真的没有广告，看剧体验太棒了。已经推荐给身边所有朋友了。',
                      rating: 5,
                    },
                    {
                      name: '李女士',
                      role: '全职妈妈',
                      comment: '少儿频道的内容特别棒，孩子很喜欢看，而且内容安全健康，作为家长很放心。我自己也经常在平台上追剧，资源真的很丰富。',
                      rating: 5,
                    },
                    {
                      name: '王同学',
                      role: '大学生',
                      comment: '不用注册就能看，太方便了！宿舍网速一般但播放也很流畅。纪录片和动漫频道的内容质量都很高，五星好评！',
                      rating: 5,
                    },
                    {
                      name: '赵先生',
                      role: 'IT工程师',
                      comment: '从技术角度看，星空传媒的视频编码质量很高，在保证画质的同时做到了很好的压缩比。界面设计也很清爽，使用体验一流。',
                      rating: 5,
                    },
                  ].map((review, index) => (
                    <div key={index} className="p-5 rounded-xl bg-background-100">
                      <div className="flex items-center gap-1 mb-2">
                        {Array.from({ length: review.rating }).map((_, i) => (
                          <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                            <i className="ri-star-fill text-accent-500 text-xs"></i>
                          </div>
                        ))}
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                        "{review.comment}"
                      </p>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">{review.name}</p>
                        <p className="text-xs text-foreground-500">{review.role}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="text-lg font-heading font-semibold text-foreground-950 mb-4">
                  联系我们
                </h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  <div className="space-y-4">
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-mail-line"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">电子邮箱</p>
                        <p className="text-sm text-foreground-500">contact@xingkongchuanmei.com</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                        <i className="ri-phone-line"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">客服电话</p>
                        <p className="text-sm text-foreground-500">400-888-6666</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 flex-shrink-0">
                        <i className="ri-map-pin-line"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">公司地址</p>
                        <p className="text-sm text-foreground-500">北京市朝阳区望京科技园星空传媒大厦18层</p>
                      </div>
                    </div>
                    <div className="flex items-start gap-3">
                      <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 flex-shrink-0">
                        <i className="ri-time-line"></i>
                      </div>
                      <div>
                        <p className="text-sm font-medium text-foreground-900">工作时间</p>
                        <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                      </div>
                    </div>
                  </div>

                  <div className="rounded-xl bg-background-100 p-6">
                    <h3 className="text-base font-heading font-semibold text-foreground-950 mb-4">
                      发送消息
                    </h3>
                    <form
                      id="contact-form"
                      data-readdy-form=""
                      className="space-y-4"
                      onSubmit={async (e) => {
                        e.preventDefault();
                        const form = e.currentTarget;
                        const formData = new FormData(form);
                        const honeypot = formData.get('website_alt') as string;
                        if (honeypot && honeypot.trim()) {
                          alert('消息已发送，我们会尽快回复您！');
                          form.reset();
                          return;
                        }
                        formData.delete('website_alt');
                        try {
                          const params = new URLSearchParams();
                          formData.forEach((value, key) => {
                            params.append(key, value as string);
                          });
                          const res = await fetch('https://readdy.ai/api/form/d9tgs478l97n3eas39qg', {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                            body: params.toString(),
                          });
                          if (res.ok) {
                            const text = await res.text();
                            let serverMsg = '';
                            try {
                              const parsed = JSON.parse(text);
                              serverMsg = parsed?.meta?.message || parsed?.message || '';
                            } catch { /* */ }
                            if (serverMsg && serverMsg.includes('spam')) {
                              alert('发送失败，请稍后重试。');
                              return;
                            }
                            alert('感谢您的留言！我们会尽快回复您。');
                            form.reset();
                          } else {
                            alert('发送失败，请稍后重试。');
                          }
                        } catch {
                          alert('网络错误，请稍后重试。');
                        }
                      }}
                    >
                      <div>
                        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          姓名
                        </label>
                        <input
                          type="text"
                          id="contact-name"
                          name="name"
                          required
                          className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          邮箱
                        </label>
                        <input
                          type="email"
                          id="contact-email"
                          name="email"
                          required
                          className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                      <div>
                        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                          留言内容
                        </label>
                        <textarea
                          id="contact-message"
                          name="message"
                          required
                          maxLength={500}
                          rows={4}
                          className="w-full px-4 py-2.5 text-sm rounded-lg bg-background-50 border border-background-200 text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                          placeholder="请输入您的留言内容（最多500字）"
                        ></textarea>
                      </div>
                      <input
                        type="text"
                        name="website_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                        className="hp-field"
                      />
                      <button
                        type="submit"
                        className="w-full py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                      >
                        发送消息
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: '关于星空传媒',
          description: '星空传媒致力于为用户提供最优质的高清影视内容，了解品牌故事、口碑评价及联系方式。',
          url: 'https://sportzup.github.io/about',
          about: {
            '@type': 'Organization',
            name: '星空传媒',
            url: 'https://sportzup.github.io/',
            description: '星空传媒在线视频平台，提供全系列高清影视资源免费在线观看',
            foundingDate: '2020',
            contactPoint: {
              '@type': 'ContactPoint',
              telephone: '400-888-6666',
              contactType: 'customer service',
              availableLanguage: 'Chinese',
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: '望京科技园星空传媒大厦18层',
              addressLocality: '北京',
              addressRegion: '朝阳区',
              addressCountry: 'CN',
            },
          },
        })}
      </script>
    </>
  );
}